import { cn } from "@/lib/utils";
import { ClassValue } from "clsx";
import { ReactNode } from "react";

type ContainerPropsType = {
  narrow?: boolean;
  className?: ClassValue;
  children: ReactNode;
};

function Container({ narrow, className, children }: ContainerPropsType) {
  return (
    <div className={cn("mx-auto px-6 py-8", narrow ? "max-w-3xl" : "max-w-7xl", className)}>
      {children}
    </div>
  );
}

export default Container;
